<template>
  <div class="wrapper">
    <div class="tech-dropdown">
      <div class="tech-dropdown-toggle">
        <a href="javascript:void(0);" @click="ddToggle">
          <i class="material-icons-outlined align-middle">more_horiz</i>
        </a>
      </div>
      <div class="tech-dropdown-menu" v-show="params.data.ddOpen">
        <ul>
          <li>
            <a href="javascript:void(0);" @click="editRole">
              <i class="material-icons align-middle">edit</i>
              Edit
            </a>
          </li>
          <li>
            <a href="javascript:void(0);" @click="deleteRole">
              <i class="material-icons align-middle">delete</i>
              Delete
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isOpen() {
      return this.params.data.ddOpen;
    },
  },
  watch: {
    isOpen: function (val) {
      if (val && this.$el) {
        let offset = this.$el.getBoundingClientRect();
        if (document.body.clientHeight - offset.top < 230) {
          this.$el.querySelector(".tech-dropdown-menu").style.top = "auto";
          this.$el.querySelector(".tech-dropdown-menu").style.bottom = "37px";
        } else {
          this.$el.querySelector(".tech-dropdown-menu").style.top = "40px";
          this.$el.querySelector(".tech-dropdown-menu").style.bottom = "auto";
        }
      }
    },
  },
  created() {
    const val = this.params.data.ddOpen;
    if (val && this.$el) {
      let offset = this.$el.getBoundingClientRect();
      if (document.body.clientHeight - offset.top < 230) {
        this.$el.querySelector(".tech-dropdown-menu").style.top = "auto";
        this.$el.querySelector(".tech-dropdown-menu").style.bottom = "37px";
      } else {
        this.$el.querySelector(".tech-dropdown-menu").style.top = "40px";
        this.$el.querySelector(".tech-dropdown-menu").style.bottom = "auto";
      }
    }
  },
  methods: {
    ddToggle: function () {
      this.params.data.ddOpen = !this.params.data.ddOpen;
      this.params.context.componentParent.openCurrentAgDropdown(
        this.params.data,
        this.$el
      );
    },
    editRole: function () {
      this.ddToggle();
      this.params.context.componentParent.editRole(this.params.data);
    },
    deleteRole: function () {
      this.ddToggle();
      this.params.context.componentParent.deleteRole(this.params.data);
    },
  },
};
</script>

<style scoped>
.wrapper {
  height: 68px;
  display: flex;
  align-items: center;
}
</style>
